import { createFileRoute } from '@tanstack/react-router'
import { RecurringEditor } from './-RecurringEditor'

export const Route = createFileRoute('/finance/recurring/$id')({
  component: RecurringDetailPage,
})

function RecurringDetailPage() {
  const { id } = Route.useParams()
  return <RecurringEditor id={id} />
}
